import React from "react";
import { Router, Route, Redirect, Switch } from "react-router-dom";
import { history } from "./browserHistory";
import * as routes from "./utils/routes";
import { getLinkTo } from "./utils/routes/navigate";

// Rounting utilities
import ScrollToTop from "./components/ScrollToTop";
import PrivateRoute from "./containers/PrivateRoute";

// Scene Components
import Landing from "./scenes/Landing";
import { AppContainer } from "./containers/AppContainer/AppContainer";
import LoginScene from "./scenes/Login";
import { ForgotScene } from "./scenes/Auth/Forgot";
import IssuesScene from "./scenes/Issues";
import ResetScene from "./scenes/ResetScene";
import ProjectSettings from "./scenes/ProjectSettings";
import { ViewActionScene } from "./scenes/Action/ViewAction";
import { CreateActionScene } from "./scenes/Action/CreateAction";
import { EditActionScene } from "./scenes/Action/EditAction";
import SiteDetails from "./scenes/Analysis/SiteDetails";

// Legacy routes
// TODO: Refactor or remove when possible
import UserAdminScene from "./scenes/UserAdmin";
import GroupAdminScene from "./scenes/GroupAdmin";
import UserProfileScene from "./scenes/UserProfile";
import NotFound from "./containers/NotFound/NotFound";

// Kill With Fire components
import ReportSummaryScene from "./scenes/Reports/Summary";
import ReportGeneratorScene from "./scenes/Reports/Generator";
import { AnalysisScene } from "./scenes/Analysis";
import { PerformanceScene } from "./scenes/Reports/Performance";

import { AnalysisProvider } from "./context/analysis";
import { InsightsProvider } from "./context/insights";
import { WorkflowProvider } from "./context/reports/workflow";
import { ComfortProvider } from "./context/reports/comfort";
import { UtilitiesProvider } from "./context/reports/utilities";

import "semantic-ui-css/semantic.min.css";
import "./custom.css";

const AppRouter = () => (
  <Router history={history}>
    <ScrollToTop>
      <AppContainer>
        <Switch>
          {/* Landing/root - redirects based on auth */}
          <PrivateRoute exact path="/" component={Landing} />
          {/* PRIVATE ROUTES */}

          {/* Project Settings */}
          <PrivateRoute
            path="/settings/:insightType"
            component={ProjectSettings}
          />

          {/* Site Details */}
          <PrivateRoute path={routes.SITE_DETAILS} component={SiteDetails} />

          {/* Analysis (Insights and Monitoring) */}
          <Redirect
            from="/triage/:syncoId/:ruleId"
            to={getLinkTo(routes.INSIGHT_EQUIPS)}
          />
          <Redirect from="/triage" to={getLinkTo(routes.INSIGHTS)} />
          <Redirect from="/insights" to={getLinkTo(routes.INSIGHTS)} />
          <Redirect from="/monitoring" to={getLinkTo(routes.MONITORING)} />
          <PrivateRoute path={routes.ANALYSIS} component={AnalysisScene} />

          {/* Actions */}
          <Redirect from="/issues" to={routes.ACTIONS} />
          <PrivateRoute exact path={routes.ACTIONS} component={IssuesScene} />
          <PrivateRoute
            exact
            path={routes.ADD_ACTION}
            component={CreateActionScene}
          />
          <PrivateRoute
            exact
            path={routes.EDIT_ACTION}
            component={EditActionScene}
          />
          <Redirect exact from="/issue/:actionId" to={routes.VIEW_ACTION} />
          <PrivateRoute
            exact
            path={routes.VIEW_ACTION}
            component={ViewActionScene}
          />

          {/* Reports */}
          <Redirect
            exact
            from={routes.REPORTS.Root}
            to={getLinkTo(routes.REPORTS.Summary)}
          />
          <PrivateRoute
            exact
            path={routes.REPORTS.Summary}
            component={ReportSummaryScene}
          />
          <PrivateRoute
            exact
            path={routes.REPORTS.Generator}
            component={ReportGeneratorScene}
          />
          <PrivateRoute
            path={routes.REPORTS.Performance}
            component={PerformanceScene}
          />

          {/* Admin */}
          <PrivateRoute
            exact
            path={routes.USER_PROFILE}
            component={UserProfileScene}
          />
          <PrivateRoute
            exact
            path={routes.USER_ADMIN}
            component={UserAdminScene}
          />
          <PrivateRoute
            exact
            path={routes.GROUP_ADMIN}
            component={GroupAdminScene}
          />

          {/* PUBLIC ROUTES */}
          <Route exact path={routes.LOGIN} component={LoginScene} />
          <Route exact path={routes.FORGOT} component={ForgotScene} />
          <Route exact path={routes.RESET} component={ResetScene} />

          {/* 404 / No match */}
          <Route component={NotFound} />
        </Switch>
      </AppContainer>
    </ScrollToTop>
  </Router>
);

const Root = () => (
  <WorkflowProvider>
    <ComfortProvider>
      <UtilitiesProvider>
        <AnalysisProvider>
          <InsightsProvider>
            <AppRouter />
          </InsightsProvider>
        </AnalysisProvider>
      </UtilitiesProvider>
    </ComfortProvider>
  </WorkflowProvider>
);

export default Root;
